export default __webpack_public_path__ + "static/media/post-incident.0fc7853d.png";